// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2zJ12","insightsList":"newBusinessInsightsMenu_insightsList__1cIFV","active":"newBusinessInsightsMenu_active__3WY5a"};